var acc = document.getElementsByClassName("accordionfilter");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function () {
    this.classList.toggle("active");
    var panelfilter = this.nextElementSibling;
    if (panelfilter.style.maxHeight) {
      panelfilter.style.maxHeight = null;
    } else {
      panelfilter.style.maxHeight = panelfilter.scrollHeight + "px";
    }
  });
}
